import React, { useEffect } from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  Row,
  Col,
  Badge,
  CardTitle,
  Card,
  CardHeader,
  CardBody,
  Table
} from "reactstrap";
import moment from 'moment'
import Skeleton from '../../components/vwSkeleton/vwSkeleton';
import {
  closeEditDeviceModal,
  getDeviceDetails,
  openEditDeviceModal
} from "../../store/deviceDetails/actions";
import {
  CUSTOMER,
  MANUFACTURER,
  ORGANIZATION_ADMIN,
  SUPER_ADMIN
} from "../../store/users/role.constants";
import VWSpinner from "../../components/vwSpinner/vwSpinner";
import Message from "../../CommonData/Data/Message";
import VWLoading from "../../components/vwLoading/vwLoading";
import UITooltip from "../../CommonData/Data/UITooltip";

const DeviceDetails = (props) => {

  const { deviceDetails, isGetDeviceDetailsPending, currentProfile, errorMessage } = props;

  const params = useParams();
  const { id } = params;
  useEffect(() => {
    props.getDeviceDetails(id);
  }, [props.getDeviceDetails, id]);

  const handleCloseEditDeviceModal = () => {
    const { closeEditDeviceModal } = props;
    closeEditDeviceModal();
  };

  const handleOpenEditDeviceModal = () => {
    const { openEditDeviceModal } = props;
    openEditDeviceModal();
  };

  const isAdmin = currentProfile && currentProfile.roles && currentProfile.roles.length > 0 &&
    (currentProfile.roles[0].roleKey === SUPER_ADMIN || currentProfile.roles[0].roleKey === ORGANIZATION_ADMIN);
  const isEnduser = currentProfile && currentProfile.roles && currentProfile.roles.length > 0 &&
    currentProfile.roles[0].roleKey === CUSTOMER;
  const isManufacturer = currentProfile.roles && currentProfile.roles.length > 0 &&
    currentProfile.roles[0].roleKey === MANUFACTURER;
  // const roleDisplayName = props.userDetails.roles && props.userDetails.roles[0]?.roleDisplayName;
  // const orgName = props.userDetails.roles && props.userDetails.roles[0]?.orgName;

  return (
    <Fragment>
      <div className="page-content">
        <Card>
          <CardTitle className="mb-0 p-2 d-flex justify-content-between align-items-center fs-5 text-dark fw-bold" >
            DEVICE DETAILS
            {(isManufacturer) && <div className="content-heading">
              <div className="ml-auto">
                <Link
                  type="button"
                  className="me-1 btn btn-primary btn-sm"
                  to="edit"
                >
                  <em className="far fa-edit me-2"></em> Edit Device
                </Link>
              </div>
            </div>}
          </CardTitle>
        </Card>
        {errorMessage && (
          <Message
            type="danger"
            defaultMessage={errorMessage}
            baseClassName="alert"
          />
        )}
        <Row className="justify-content-center">
          {isGetDeviceDetailsPending ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
              <Skeleton type="base" />
              {/* <VWSpinner height={40} width={40} /> */}
              <VWLoading height={40} width={40} />
            </div>
          ) : (
            deviceDetails && (
              <Row>
                <Col xl={isEnduser ? `12` : `7`}>
                  {/* Main card */}
                  <Card>
                    <CardTitle className='p-3 pb-0 border-bottom'>
                      <h5>
                        <span>{deviceDetails.name || "NA"}</span>
                      </h5>
                    </CardTitle>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="table-responsive">
                            <Table className="table table-bordered table-striped table-hover text-nowrap">
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Serial Number</strong>
                                  </td>
                                  <td>{deviceDetails.deviceKey || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Device UID</strong>
                                  </td>
                                  <td>{deviceDetails.uid || "NA"}
                                    {!deviceDetails.warningMessage.every(item => item === null) &&
                                      <UITooltip id={`warning-${deviceDetails.uid}`} content={deviceDetails.warningMessage?.map((i) => { return i })}>
                                        <i class="fas fa-exclamation-triangle text-danger ms-1" style={{ cursor: "pointer" }} />
                                      </UITooltip>
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Model Number</strong>
                                  </td>
                                  <td>{deviceDetails.modelNo || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Description</strong>
                                  </td>
                                  <td>{deviceDetails.description || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Hardware Version</strong>
                                  </td>
                                  <td>
                                    {deviceDetails.hardwareVersion || "NA"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Firmware Version</strong>
                                  </td>
                                  <td>
                                    {deviceDetails.firmwareVersion || "NA"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Functionality</strong>
                                  </td>
                                  <td>
                                    {deviceDetails.functionality || "NA"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Lot Number</strong>
                                  </td>
                                  <td>{deviceDetails.sensorType || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Organization</strong>
                                  </td>
                                  <td>{deviceDetails.orgName || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Assign Status</strong>
                                  </td>
                                  <td>
                                    {deviceDetails.isAssigned ? (
                                      <Badge color="success">Assigned</Badge>
                                    ) : (
                                      <Badge color="danger">Unassigned</Badge>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Active Status</strong>
                                  </td>
                                  <td>
                                    {deviceDetails.isActive ? (
                                      <Badge color="success">Active</Badge>
                                    ) : (
                                      <Badge color="danger">Inactive</Badge>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Subscription Validity</strong>
                                  </td>
                                  <td>{deviceDetails.subcriptionValidity ? moment(deviceDetails.subcriptionValidity).format("DD MMM yyyy") : "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>AMC Status</strong>
                                  </td>
                                  <td>{deviceDetails.amcStatus || "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>AMC Start Date</strong>
                                  </td>
                                  <td>{deviceDetails.amcStartDate ? moment(deviceDetails.amcStartDate).format("DD MMM yyyy") : "NA"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>AMC End Date</strong>
                                  </td>
                                  <td>{deviceDetails.amcEndDate ? moment(deviceDetails.amcEndDate).format("DD MMM yyyy") : "NA"}</td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                {!isEnduser && (
                  <Col xl="5">
                    <Card>
                      <CardTitle className='p-3 pb-0 border-bottom'>
                        <h5>
                          DEVICE ALLOCATIONS
                        </h5>
                      </CardTitle>
                      <CardBody>
                        {deviceDetails.assignedUsers &&
                          deviceDetails.assignedUsers.length ? (
                          <div className="list-group">
                            {deviceDetails.assignedUsers.map((data, index) => (
                              <div className="list-group-item" key={data.id}>
                                <div className="media">
                                  <div className="align-self-start mr-2">
                                    <span className="fa-stack">
                                      <em className="fa fa-circle fa-stack-2x text-info"></em>
                                      <em className="far fa-clock fa-stack-1x fa-inverse text-white"></em>
                                    </span>
                                  </div>
                                  <div className="media-body text-truncate">
                                    <p className="mb-1 mt-1">
                                      {data.type.toLowerCase() === 'return' ? 'Returned to ' : data.type.toLowerCase() === 'transfer' ? 'Transferred to ' : 'Assigned to '}<b>{data.toDisplayName}</b>
                                    </p>
                                    <p className="m-0">
                                      <small>
                                        From{" "}
                                        <em>
                                          <b>{data.fromDisplayName || "NA"}</b>
                                        </em>
                                      </small>
                                    </p>
                                  </div>
                                  <div className="ml-auto">
                                    <small className="text-muted ml-2">
                                      {data.userAssignedDate ? moment(data.userAssignedDate).fromNow() : "NA"}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <Fragment>
                            <div>No records found</div>
                          </Fragment>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>
            )
          )}
        </Row>
      </div>
    </Fragment >

  );
}

const mapStateToProps = (state) => ({
  deviceDetails: state.deviceDetails.device,
  errorMessage: state.deviceDetails.deviceDetailsError,
  isGetDeviceDetailsPending: state.deviceDetails.isGetDeviceDetailsPending,
  isEditDeviceModalOpen: state.deviceDetails.isEditDeviceModalOpen,
  currentProfile: state.login.currentProfile,
});

const mapDispatchToProps = (dispatch) => ({
  getDeviceDetails: (id) => dispatch(getDeviceDetails(id)),
  closeEditDeviceModal: () => dispatch(closeEditDeviceModal()),
  openEditDeviceModal: () => dispatch(openEditDeviceModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceDetails);
